// {@see CdnParser}

module.exports = {
  parsers: [{
    element: 'name',
    headerName: null,
    regex: /(.+)/
  }]
}



//////////////////
// WEBPACK FOOTER
// ./src/comm/transform/resourceparsers/cdnparsers/balancer.js
// module id = 30
// module chunks = 0